<template>
  <div class="user-account">Баланс: <v-chip
      class="ml-1"
      :color="getAccountColor(account)"
      small
    >{{splitNumber(account)}}</v-chip>
    <span class="ml-3">Бонусный баланс:</span>
    <v-chip
      class="ml-1"
      :color="getAccountColor(accountBonus)"
      small
    >{{splitNumber(accountBonus)}}</v-chip>
    <span class="ml-3">Итого:</span>
    <v-chip
      class="ml-1"
      :color="getAccountColor(totalAccount)"
      small
    >{{splitNumber(totalAccount)}}</v-chip>
    <v-btn
      class="ml-3"
      text
      x-small
      color="warning"
      @click="changeAccountDialog = true"
    >
      Изменить
    </v-btn>

    <change-account-dialog
      v-model="changeAccountDialog"
      :account-bonus="accountBonus"
      :user-id="userId"
      @create-transaction="createTransactionHandle($event)"
    />
  </div>
</template>

<script>
import { NumberMixin, UserAccount } from '@/mixins';
import ChangeAccountDialog from './ChangeAccountDialog';

export default {
  mixins: [NumberMixin, UserAccount],

  components: {
    ChangeAccountDialog
  },

  props: {
    userId: {
      type: [Number, String],
      required: true
    },

    account: {
      type: [Number, String],
      default: 0
    },

    accountBonus: {
      type: [Number, String],
      default: 0
    }
  },

  data: () => ({
    changeAccountDialog: false
  }),

  computed: {
    totalAccount() {
      return (parseInt(this.account) || 0) + (parseInt(this.accountBonus) || 0);
    }
  },

  methods: {
    createTransactionHandle(value) {
      this.$emit("create-transaction", value);
    }
  }
};
</script>
